
const SCORM_12_CMI_MODEL = {
    cmi: {
        _BIW_SCORM_version: 'SCORM 1.2',
        comments: '',
        comments_from_lms: '',
        core: {
            credit: 'credit',
            entry: 'ab-initio',
            exit: '',
            lesson_location: '',
            lesson_mode: 'normal',
            lesson_status: 'not attempted',
            score: {
                max: '',
                min: '',
                raw: '',
            },
            session_time: '0000:00:00.00',
            student_id: '',
            student_name: '',
            total_time: '0000:00:00.00',
        },
        interactions: [],
        launch_data: '',
        objectives: [],
        student_data: {
            mastery_score: '',
            max_time_allowed: '',
            time_limit_action: '',
        },
        student_preference: {
            audio: '',
            language: '',
            speed: '',
            text: '',
        },
        suspend_data: '',
    },
};

export default SCORM_12_CMI_MODEL;